import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import InventoryItem from './InventoryItem';

const CategorySection = ({ 
  category, 
  items, 
  onEdit, 
  onDelete, 
  onQuantityAdjust,
  isExpanded,
  onToggle 
}) => {
  const categoryIcons = {
    Fresh: 'Leaf',
    Refrigerated: 'Refrigerator',
    Canned: 'Package',
    Dry: 'Wheat',
    Snack: 'Cookie',
    Condiment: 'Droplet'
  };

  const categoryColors = {
    Fresh: 'text-emerald-600 dark:text-emerald-400',
    Refrigerated: 'text-blue-600 dark:text-blue-400',
    Canned: 'text-amber-600 dark:text-amber-400',
    Dry: 'text-orange-600 dark:text-orange-400',
    Snack: 'text-purple-600 dark:text-purple-400',
    Condiment: 'text-red-600 dark:text-red-400'
  };

  const totalItems = items?.length;
  const totalQuantity = items?.reduce((sum, item) => sum + item?.quantity, 0);

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between p-4 md:p-5 lg:p-6 hover:bg-muted transition-colors duration-200"
        aria-expanded={isExpanded}
      >
        <div className="flex items-center gap-3 md:gap-4">
          <div className={`${categoryColors?.[category]} flex-shrink-0`}>
            <Icon name={categoryIcons?.[category]} size={24} />
          </div>
          <div className="text-left">
            <h3 className="text-base md:text-lg font-semibold text-foreground">
              {category}
            </h3>
            <p className="text-xs md:text-sm text-muted-foreground mt-0.5">
              {totalItems} {totalItems === 1 ? 'item' : 'items'} • {totalQuantity} total units
            </p>
          </div>
        </div>
        <Icon 
          name={isExpanded ? 'ChevronUp' : 'ChevronDown'} 
          size={20} 
          className="text-muted-foreground flex-shrink-0"
        />
      </button>
      {isExpanded && (
        <div className="border-t border-border">
          {items?.length === 0 ? (
            <div className="p-6 md:p-8 text-center">
              <Icon 
                name="Package" 
                size={48} 
                className="text-muted-foreground mx-auto mb-3"
              />
              <p className="text-sm text-muted-foreground">
                No items in this category yet
              </p>
            </div>
          ) : (
            <div className="divide-y divide-border">
              {items?.map((item) => (
                <InventoryItem
                  key={item?.id}
                  item={item}
                  onEdit={onEdit}
                  onDelete={onDelete}
                  onQuantityAdjust={onQuantityAdjust}
                />
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CategorySection;